// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lightColor[data-v-697f6246]{background-color:#f5f5f9;color:#000}.commonBtnL[data-v-697f6246],.deepColor[data-v-697f6246]{background-color:#879dc9;color:#fff}.commonBtnL[data-v-697f6246]{line-height:2.5rem;width:-moz-fit-content;width:fit-content;cursor:pointer;width:100%;border-radius:5px;height:2.7rem;text-align:center;padding:.2rem .4rem}", ""]);
// Exports
module.exports = exports;
